import * as React from "react";
const SvgFiRrCheap = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cheap_svg__a)">
      <path
        fill="#062147"
        d="M9.994 19.11a1 1 0 0 1-.993.89C3.933 19.439 0 15.137 0 10 0 4.486 4.486 0 10 0c1.561 0 3.056.35 4.445 1.04a1 1 0 0 1-.889 1.791A7.9 7.9 0 0 0 10 2c-4.411 0-8 3.589-8 8 0 4.116 3.057 7.558 7.11 8.006a1 1 0 0 1 .884 1.104M10 6a1 1 0 0 0 0-2c-3.309 0-6 2.691-6 6s2.691 6 6 6a1 1 0 0 0 0-2c-2.206 0-4-1.794-4-4s1.794-4 4-4m13.707 12.174a1 1 0 0 0-1.414 0L19 21.467V1a1 1 0 0 0-2 0v20.366l-3.293-3.293a.999.999 0 1 0-1.414 1.414l3.636 3.636A3 3 0 0 0 18.05 24a3 3 0 0 0 2.121-.877l3.536-3.536a1 1 0 0 0 0-1.413"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cheap_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheap;
